/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./accountMgmtSuperAdminTerminal.vue?vue&type=template&id=050e6ab5&scoped=true"
import script from "./accountMgmtSuperAdminTerminal.vue?vue&type=script&lang=js"
export * from "./accountMgmtSuperAdminTerminal.vue?vue&type=script&lang=js"
import style0 from "./accountMgmtSuperAdminTerminal.vue?vue&type=style&index=0&id=050e6ab5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050e6ab5",
  null
  
)

export default component.exports